import * as React from 'react';
import { Modal } from '../../common/modal/modal.component';
import { Terms } from './terms.component';
import { Disclosure } from './disclosure.component';
import { Privacy } from './privacy.component';

import styles from './footer.module.css';

interface TFooterProps {
	containerClass?: string;
}

export const FooterComponent: React.FC<TFooterProps> = props => {
	const [privacyModal, setPrivacyModal] = React.useState(false);
	const [termModal, setTermModal] = React.useState(false);
	const [disclouserModal, setDisclouserModal] = React.useState(false);

	const togglePrivacyModal = () => {
		setPrivacyModal(!privacyModal);
	};
	const toggleTermModal = () => {
		setTermModal(!termModal);
	};
	const toggleDisclouserModal = () => {
		setDisclouserModal(!disclouserModal);
	};

	const renderModals = () => {
		return (
			<div>
				{privacyModal && (
					<Modal
						id={'openPrivacyModal'}
						body={<Privacy onCloseModalClick={togglePrivacyModal} onPrintModalClick={printPolicyData} />}
						footer={<div />}
						title={'Privacy and Security Policy'}
						onCloseModalClick={togglePrivacyModal}
					/>
				)}

				{termModal && (
					<Modal
						id={'openTermModal'}
						body={<Terms onCloseModalClick={toggleTermModal} onPrintModalClick={printTermData} />}
						footer={<div />}
						title={'Terms of Use'}
						onCloseModalClick={toggleTermModal}
					/>
				)}

				{disclouserModal && (
					<Modal
						id={'openDisclosureModal'}
						body={
							<Disclosure
								onCloseModalClick={toggleDisclouserModal}
								onPrintModalClick={printDisclouserData}
							/>
						}
						footer={<div />}
						title={'Supported Browsers'}
						onCloseModalClick={toggleDisclouserModal}
					/>
				)}
			</div>
		);
	};

	const printPolicyData = (): void => {
		const printContent: HTMLElement | null | string = document.getElementById('privacyPolicy') as HTMLElement;
		const printContents = printContent.innerHTML;

		const newWindow = window.open('', 'Privacy Policy');
		newWindow?.document.write('<html><head><title>Privacy Policy</title>');
		newWindow?.document.write(`<style>
		@media print {
			.privacy .section-header{
				text-decoration: none !important;
				font-size: 18pt !important;
				font-weight: normal !important;
			}
			.privacy .policy-header{
				font-size: 22pt !important;
				font-weight: normal !important;
			}
			.privacy ul{
				list-style: disc !important;
				margin-left: 20px !important;
				line-height: 115% !important;
				font-size: 12pt !important;
			}
		  }
		</style>`);
		newWindow?.document.write('</head><body>');
		newWindow?.document.write(printContents);
		newWindow?.document.write('</body></html>');
		newWindow?.document.close();
		newWindow?.focus();
		newWindow?.focus();
		newWindow?.print();
		newWindow?.close();
	};

	const printTermData = (): void => {
		const frame: HTMLIFrameElement = document.getElementById("iframe") as HTMLIFrameElement;
		frame.contentWindow && frame.contentWindow.print();
		// const printContent: HTMLElement | null | string = document.getElementById('termofUse') as HTMLElement;
		// const printContents = printContent.innerHTML;

		// const newWindow = window.open('', 'Term of Use');
		// newWindow?.document.write('<html><head><title>TermsofUse</title>');
		// newWindow?.document.write(`<style>
		// @media print {
		// 	.term-policy-padding{
		// 		padding-bottom: 10px;
		// 	}
		// 	.policy .policy-header{
		// 		font-size: 28pt;
		// 		font-weight: bold;
		// 		margin-top: 5pt;
		// 		margin-bottom: 5pt;
		// 	}
		// 	.policy .policy-header-2{
		// 		font-size: 22pt;
		// 		font-weight: bold;
		// 		margin-top: 5pt;
		// 		margin-bottom: 5pt;
		// 	}
		// 	.policy p {
		// 		margin-top: 5pt;
		// 		margin-bottom: 5pt;
		// 		line-height: normal;
		// 		font-size: 12pt;
		// 	}
		// 	.policy .section-header{
		// 		font-weight: bold;
		// 		text-decoration: underline;
		// 	}
		//   }
		// </style>`);
		// newWindow?.document.write('</head><body>');
		// newWindow?.document.write(printContents);
		// newWindow?.document.write('</body></html>');
		// newWindow?.document.close();
		// newWindow?.focus();
		// newWindow?.print();
		// newWindow?.close();
	};

	const printDisclouserData = (): void => {
		const frame: HTMLIFrameElement = document.getElementById("iframeDisclosure") as HTMLIFrameElement;
		frame.contentWindow && frame.contentWindow.print();
		// Changed Print functionality to print Iframe Content
		// const printContent: HTMLElement | null | string = document.getElementById('printDisclouser') as HTMLElement;
		// const printContents = printContent.innerHTML;
		// const newWindow = window.open('', 'policy disclosure');
		// newWindow?.document.write('<html><head><title>Supported Brower</title>');
		// newWindow?.document.write(`<style>
		// @media print {
		// 	.privacy .section-header{
		// 		text-decoration: none !important;
		// 		font-size: 18pt !important;
		// 		font-weight: normal !important;
		// 	}
		// 	.privacy .policy-header{
		// 		font-size: 22pt !important;
		// 		font-weight: normal !important;
		// 	}
		// 	.privacy ul{
		// 		list-style: disc !important;
		// 		margin-left: 20px !important;
		// 		line-height: 115% !important;
		// 		font-size: 12pt !important;
		// 	}
		//   }
		// </style>`);
		// newWindow?.document.write('</head><body>');
		// newWindow?.document.write(printContents);
		// newWindow?.document.write('</body></html>');
		// newWindow?.document.close();
		// newWindow?.focus();
		// newWindow?.focus();
		// newWindow?.print();
		// newWindow?.close();
	};

	return (
		<div className={styles.footerBg + ' ' + props.containerClass}>
			<div>
				<div className={styles.footerFlex}>
					<a className={styles.footerLinkPrivacy} onClick={togglePrivacyModal}>
						{' '}
						Privacy and Security Policy
					</a>
					<a className={styles.footerLinkTerm} onClick={toggleTermModal}>
						{' '}
						Terms of Use{' '}
					</a>
					<a className={styles.footerLinkSupprtedBrower} onClick={toggleDisclouserModal}>
						{' '}
						Supported Browsers{' '}
					</a>
				</div>
				<div className={styles.footerCopyText}>
					Copyright &#169; {new Date().getFullYear()} AssetMark, Inc. All right reserved.
				</div>
			</div>
			{renderModals()}
		</div>
	);
};
